import { useEffect, useState } from "react";

const CARDS = [
    { name: "Amazon", brand: "a", bg: "bg-black", accent: "text-amber-400", angle: -18, top: "8%", right: "-2%", delay: "0s", z: 5, w: 230 },
    { name: "Google Play", brand: "▶", bg: "bg-white border border-slate-200", accent: "text-emerald-500", angle: 14, top: "30%", right: "-12%", delay: "0.6s", z: 6, w: 180 },
    { name: "PayPal", brand: "P", bg: "bg-[#003087]", accent: "text-white", angle: -8, top: "55%", right: "-4%", delay: "1.2s", z: 7, w: 200 },
    { name: "Steam", brand: "S", bg: "bg-[#1B2838]", accent: "text-white", angle: 22, top: "70%", right: "8%", delay: "1.8s", z: 4, w: 160 },
    { name: "Apple", brand: "", bg: "bg-black", accent: "text-white", angle: -12, top: "78%", right: "-14%", delay: "2.4s", z: 8, w: 175 },
];

function MiniCard({ name, brand, bg, accent, angle, top, right, delay, z, w }) {
    return (
        <div className="absolute rounded-2xl shadow-floating animate-float-slow"
            style={{ top, right, width: w, aspectRatio: "16 / 10", transform: `rotate(${angle}deg)`, animationDelay: delay, zIndex: z }}
            aria-hidden="true">
            <div className={`w-full h-full rounded-2xl p-3 flex flex-col justify-between ${bg}`}>
                <div className="flex items-center justify-between">
                    <span className={`text-2xl font-heading font-bold ${accent}`}>{brand}</span>
                    <span className="text-[10px] text-white/70 uppercase tracking-widest">Gift Card</span>
                </div>
                <div className="flex items-end justify-between">
                    <div className={`text-sm font-bold ${accent}`}>{name}</div>
                    <div className={`text-xs font-mono ${accent} opacity-70`}>•••• 8624</div>
                </div>
            </div>
        </div>
    );
}

export default function HeroFloatingCards() {
    // Defer rendering until after main content loads
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        const t = setTimeout(() => setMounted(true), 300);
        return () => clearTimeout(t);
    }, []);

    if (!mounted) return null;

    return (
        <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
            <div className="absolute -right-12 top-10 w-[420px] h-[420px] rounded-full"
                style={{ background: "radial-gradient(closest-side, rgba(251,191,36,0.18), transparent 70%)", zIndex: 0 }} />
            {/* Reduced sparkles for performance */}
            {[
                { top: "12%", right: "10%", size: 6 },
                { top: "62%", right: "0%", size: 5 },
                { top: "20%", right: "52%", size: 3 },
            ].map((s, i) => (
                <span key={i} className="absolute rounded-full bg-amber-400 animate-float-slow"
                    style={{ top: s.top, right: s.right, width: s.size, height: s.size, animationDelay: `${i * 0.4}s`, boxShadow: "0 0 10px rgba(251,191,36,0.6)" }} />
            ))}
            {CARDS.map((c) => <MiniCard key={c.name} {...c} />)}
            <div className="absolute bottom-2 right-6 flex items-end gap-1 z-10">
                {[1, 2, 3].map((i) => (
                    <div key={i} className="rounded-full bg-amber-400 border-2 border-amber-500 animate-float-slow"
                        style={{ width: 22 + i * 4, height: 22 + i * 4, animationDelay: `${i * 0.5}s`, boxShadow: "inset 0 -4px 8px rgba(0,0,0,0.15)" }} />
                ))}
            </div>
        </div>
    );
}